import { HStack, Checkbox as ChakraCheckbox } from '@chakra-ui/react';

import { FilterOption } from '../FilterSelect';

const FilterOptionItem = ({ option, isSelected, onToggle }: { option: FilterOption; isSelected: boolean; onToggle: (value: string) => void }) => (
  <HStack
    key={option.value}
    gap={3}
    p={2}
    borderRadius="4px"
    _hover={{ backgroundColor: 'gray.50' }}
    cursor="pointer"
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      onToggle(option.value);
    }}
    transition="background-color 0.2s"
  >
    <ChakraCheckbox.Root checked={isSelected} onCheckedChange={() => onToggle(option.value)} colorScheme="purple">
      <ChakraCheckbox.HiddenInput />
      <ChakraCheckbox.Control
        _checked={{
          backgroundColor: 'purple.500',
          borderColor: 'purple.500',
          color: 'white',
        }}
      />
      <ChakraCheckbox.Label>{option.label}</ChakraCheckbox.Label>
    </ChakraCheckbox.Root>
  </HStack>
);

export default FilterOptionItem;
